import Button from "../Button";
const TabNavItem = ({ parentStyle, childStyle, onClick, title }) => {
    return (<li class={parentStyle} onClick={onClick}>
        <Button style={childStyle} type={"button"} title={title} />
    </li>)
}
export default TabNavItem;